<template>
	<div id="addVendorModal" style="display: block" class="modal" role="dialog">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div id="add-vendor-dialog" class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<div>
						<h3 class="uptext">Add Vendor</h3>
					</div>
				</div>
				<div class="modal-body">
					<div class="block inputCell email">
						<label>Name</label>
						<div class="input placeholder">
							<input
								v-model="vendorName"
								type="text"
								class="form-control"
								placeholder="Vendor"
								v-on:keyup.enter="addNewVendor(vendorName)"
							/>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div>
						<b-button class="btn-default btnSize" @click="$emit('close')"
							>Cancel</b-button
						>
					</div>
					<div>
						<b-button
							class="btnSize"
							variant="success"
							type="submit"
							@click="addNewVendor(vendorName)"
							>Done</b-button
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getUserId } from "../utils/auth";

export default {
	name: "CreateVendor",
	data() {
		return {
			fullPage: false,
			isLoading: false,
			vendorData: {},
			vendorName: ""
		};
	},
	components: {
		Loading
	},
	methods: {
		addNewVendor(name) {
			const self = this;
			self.isLoading = true;
			let userId = getUserId();
			this.vendorData = {
				user_id: userId,
				attribute_type: "vendor",
				old_attribute_name: name,
				new_attribute_name: name
			};
			let params = this.vendorData;
			this.$axios.post("attributes", params, { crossdomain: true }).then(
				response => {
					if (response.status === 200) {
						this.$store.dispatch("loadAttribute").finally(() => {
							self.isLoading = false;
							this.$emit("close");
						});
					}
				},
				err => {
					console.log(err);
				}
			);
		},
		onCancel() {
			console.log("User cancelled the loader.");
		}
	}
};
</script>

<style lang="scss">
// #addVendorModal {
// 	.modal-header {
// 		background-color: #fff;
// 		display: block;
// 	}
// 	.modal-body {
// 		.block {
// 			height: auto;

// 			label {
// 				position: absolute;
// 				margin-top: 8px;
// 				padding-left: 10px;
// 			}
// 			.placeholder {
// 				input {
// 					padding-left: 3rem;
// 					text-align: right;
// 					border-radius: 0.4rem;
// 				}
// 				input:focus {
// 					box-shadow: 0 0 5px rgba(47, 183, 124, 1);
// 					border: 1px solid rgba(47, 183, 124, 1);
// 				}
// 			}
// 		}
// 	}
// 	.uptext {
// 		font-size: 14px;
// 		color: #000;
// 		font-weight: bold;
// 	}
// 	.btnSize {
// 		font-size: 12px;
// 	}
// 	.form-control {
// 		font-size: 14px;
// 	}
// 	.block {
// 		border: 1px solid #fff;
// 		height: 70px;
// 	}
// 	.modal-header {
// 		height: 45px;
// 	}
// 	label {
// 		font-weight: bold;
// 		font-size: 14px;
// 	}
// 	#add-vendor-dialog {
// 		.modal-content {
// 			border-radius: 8px;
// 			border-color: #fff;
// 		}
// 		.modal-header {
// 			border-radius: 8px 8px 0px 0px;
// 		}
// 	}
// 	@media (min-width: 576px) {
// 		#add-vendor-dialog {
// 			margin: 3.75rem auto;
// 			float: right;
// 			top: 0px;
// 			margin-right: 40px;
// 			width: 300px;
// 		}
// 	}
// }
</style>
